/**
 * Императивная реализация `ActivityUiHelpers` поверх платформенных
 * синглтон-контроллеров Drawer/Modal.
 *
 * Хендлеры дескрипторов получают эти helpers аргументом и не используют хуки —
 * это делает их тестируемыми (в тестах подставляются фейковые helpers).
 */
import { DrawerController } from '@ayocore/platform/client/components/DrawerHost/DrawerController';
import { ModalController } from '@ayocore/platform/client/components/ModalHost/ModalController';
import type { ActivityUiHelpers } from './types';

let surfaceCounter = 0;

function nextSurfaceId(prefix: string): string {
  surfaceCounter += 1;
  return `activity-${prefix}-${Date.now()}-${surfaceCounter}`;
}

/** Единственный экземпляр helpers, который ядро передаёт в хендлеры расширений. */
export const activityUiHelpers: ActivityUiHelpers = {
  openDrawer(node) {
    // title в платформенном Drawer не используется (см. useDrawer) — параметр
    // сохранён в контракте на будущее, но в конфиг не передаётся.
    const controller = DrawerController.getInstance();
    const id = nextSurfaceId('drawer');
    controller.open(id, node, {}, [], false);
    return { close: () => controller.close(id) };
  },

  openModal(node, options) {
    const controller = ModalController.getInstance();
    const id = nextSurfaceId('modal');
    controller.open(
      id,
      node,
      {
        ...(options?.title ? { title: options.title } : {}),
        ...(options?.size !== undefined ? { size: options.size } : {}),
        ...(options?.inputSize ? { inputSize: options.inputSize } : {}),
      },
      []
    );
    return { close: () => controller.close(id) };
  },
};
